import { SVGProps } from 'react';

/** Scales of justice icon for Cases. */
export const ScalesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-icon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <path d="M12 4v17" />
    <path d="M8 21h8" />
    <path d="M5 7h14" />
    <path d="M5 7l-3 7h6z" />
    <path d="M19 7l-3 7h6z" />
  </svg>
);
